import iconUrl from '../../../svg/fa/regular/thumbs-up.svg'
export default {
    'fa/regular/thumbs-up': iconUrl
}
